<app-header></app-header>
<app-botao-chat></app-botao-chat>
<app-loading-generico [loadingGenerico]="loadingGenerico"></app-loading-generico>
<app-alert-sucesso-padrao (alertSucessoFechou)="sucessoFechou()"
  [descricaoSucesso]="'O download do arquivo foi realizado com sucesso.'"
  [showSucesso]="alertSucesso">
</app-alert-sucesso-padrao>

<app-alert-erro-padrao [showAlertaErro]="alertErro"
  (alertErroPadraoFechou)="alertErroFechou()"
  [descricaoErro]="descricaoErro"
></app-alert-erro-padrao>
<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <div class="div-titulo-pagina">
          <h1>Devolução Depósito em Conta</h1>
          <h2>Resumo das devoluções de pedidos</h2>
        </div>
        <div class="select-one deep-devolucoes">
          <app-select-one
            [label]="'Buscar usuários'"
            [buscaComPesquisa]="true"
            [collection]="usuarios | async"
            [panelWidth]="'595px'"
            [fieldWidth]="595"
            [searchControl]="filtroBuscaUsuarios"
            [useExternalSearch]="true"
            [selectedValue]="idUsuarioDevolucao"
            (valueChanges)="onChangeUsuario($event)">
          </app-select-one>
          <div class="tooltip-busca">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12.0098 17C11.4575 17 11.0098 16.5523 11.0098 16V12C11.0098 11.4477 11.4575 11 12.0098 11C12.5621 11 13.0098 11.4477 13.0098 12V16C13.0098 16.5523 12.5621 17 12.0098 17ZM12 7C11.4477 7 11 7.44771 11 8C11 8.55228 11.4477 9 12 9H12.001C12.5533 9 13.001 8.55229 13.001 8C13.001 7.44772 12.5533 7 12.001 7H12Z"
                fill="#505050"/>
            </svg>
            <div class="container-dropdown-devolucao">
              <span>Buscar usuários</span>
              <div class="div-dropdown-devolucao">
                <span>Você consegue realizar a busca por Nome, Matrícula ou CPF.</span>
              </div>
            </div>
          </div>
        </div>

        <div class="filtro-devolucoes deep-devolucoes">
          <div class="filtro-devolucao-pedido">
            <mat-form-field class="devolucao-pedido" appearance="outline">
              <mat-label>Número do pedido</mat-label>
              <div matPrefix class="input-icone">
                @if (numeroPedido != null) {
                  <i class="fa fa-check-circle fa-lg check" aria-hidden="true"></i>
                }
              </div>
              <input matInput type="text" maxlength="30" id="inptPedidoDevolucao" [(ngModel)]="numeroPedido" somenteNumeros>
            </mat-form-field>
          </div>

          <div class="filtro-devolucao-data">
            <mat-form-field appearance="outline" class="campo-data">
              <mat-label>Data do pedido</mat-label>
              <div matPrefix class="input-icone">
                @if (dataEmissao != null) {
                  <i class="fa fa-check-circle fa-lg check" aria-hidden="true"></i>
                }
              </div>
              <input
                matInput
                type="text"
                id="dataInicial"
                dateMask [matDatepicker]="data_inicial_picker"
                [(ngModel)]="dataEmissao"

                />
              <mat-datepicker-toggle matSuffix [for]="data_inicial_picker">
                <mat-icon matDatepickerToggleIcon><app-icon-calendar></app-icon-calendar></mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #data_inicial_picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="filtro-devolucao-tipo">
            <app-select-one [label]="'Tipo de devolução'"
              [selectedValue]="tipoDevolucao"
              (valueChanges)="alteraTipoDevolucao($event)"
                            [collection]="[
                              {label : 'Geral (todas as situações)' , id : ''},
                              {label : 'Crédito usuário' , id : 'C'},
                              {label : 'Desconto próxima fatura' , id : 'D'}
                              ]">
            </app-select-one>
          </div>

        </div>
        <div class="filtro-botao">
          <button
            type="button"
            id="btnFiltrarOcorrencias"
            mat-button
            matPrefix
            [disabled]="!campoFiltroPreenchido()"
            class="text-rigth btn botao-outline w-auto botao-filtro-devolucao"
            (click)="filtrarDevolucoes()">
            <app-icon-filter></app-icon-filter>
            FILTRAR
          </button>
          @if (campoFiltroPreenchido()) {
            <button
              class="filtro-limpar btn-icon"
              (click)="limparFiltro()"
              aria-label="Limpar filtros">
              LIMPAR FILTROS
            </button>
          }
        </div>

        @if (devolucoes || devolucoes === undefined) {
          <div class="row">
            <!-- COLUNA DOS TITULOS -->
            <div class="col-12" style="margin-top: 20px">
              <div class="row linha">
                <div class="coluna-pedido">
                  <span class="label-detalhes mb-0">Nº DO PEDIDO</span>
                </div>
                <div class="coluna-data-prev">
                  <span class="label-detalhes mb-0">DATA DO PEDIDO</span>
                </div>
                <div class="coluna-produto">
                  <span class="label-detalhes mb-0">PRODUTO</span>
                </div>
                <div class="coluna-cpf">
                  <span class="label-detalhes mb-0">CPF</span>
                </div>
                <div class="coluna-usuario">
                  <span class="label-detalhes mb-0">USUÁRIO</span>
                </div>
                <div class="coluna-departamento">
                  <span class="label-detalhes mb-0">DEPARTAMENTO</span>
                </div>
                <div class="coluna-seta"></div>
              </div>
            </div>
            @if (devolucoes === undefined) {
              <div class="col-12">
                <app-sem-resultados
                  titulo="Nenhuma devolução encontrada."
                  subtitulo="Você ainda no momento não tem nenhuma devolução criada.">
                </app-sem-resultados>
              </div>
            }
            <!-- COLUNA DOS DADOS -->
            @if (devolucoes?.dados) {
              <div class="col-12">
                @for (devolucao of $safeNavigationMigration(devolucoes?.dados) | paginate: { id: 'devolucoes', itemsPerPage: tamanho , currentPage: pagina, totalItems: totalItems}; track devolucao; let i = $index) {
                  <div class="row linha">
                    <div class="coluna-pedido">
                      <p class="descricao">{{devolucao.idPedido}}</p>
                    </div>
                    <div class="coluna-data-prev">
                      <p class="descricao">{{devolucao.dataPrevisaoEntrega | appDate: 'dd/MM/yyyy'}}</p>
                    </div>
                    <div class="coluna-produto">
                      <p class="descricao">{{devolucao.produto | camelCase}}</p>
                    </div>
                    <div class="coluna-cpf">
                      <p class="descricao">{{devolucao.cpf | cpf}}</p>
                    </div>
                    <div class="coluna-usuario">
                      <p class="descricao">{{devolucao.nomeUsuario | camelCase}}</p>
                    </div>
                    <div class="coluna-departamento">
                      <p class="descricao">{{devolucao.departamento | camelCase}}</p>
                    </div>
                    <button
                      class="btn-icon coluna-seta"
                      (click)="abreFecharResolucao(i + 1)"
                      aria-label="Abrir ou fechar resolução">
                      <i class="fa fa-chevron-down c-primary icone-abre-fecha" id="flechaResolucao{{i + 1}}"
                      aria-hidden="true"></i>
                    </button>
                    <!-- COLUNA QUE FICA ESCONDIDA E APARECE AO CLICAR NA SETA -->
                    <div class="coluna-resolucao d-none" id="colunaResolucao{{i + 1}}">
                      <div class="pri-detalhe-devolucao">
                        <div class="resolucao-detalhe">
                          <span class="label-detalhes">Valor</span>
                          <p class="descricao">{{devolucao.valor | currency: 'BRL'}}</p>
                        </div>
                        <div class="resolucao-detalhe">
                          <span class="label-detalhes">Data depósito</span>
                          @if (devolucao.dataDeposito) {
                            <p class="descricao"
                            >{{devolucao.dataDeposito | appDate: 'dd/MM/yyyy'}}</p>
                          }
                          @if (!devolucao.dataDeposito) {
                            <p class="descricao">Não consta</p>
                          }
                        </div>
                        @if (devolucao.modalidadePag) {
                          <div class="resolucao-detalhe">
                            <span class="label-detalhes">Modalidade pagamento Alelo</span>
                            <p class="descricao">{{devolucao.modalidadePag | camelCase}}</p>
                          </div>
                        }
                        @if (devolucao.chavePix) {
                          <div class="resolucao-detalhe">
                            <span class="label-detalhes">Chave Pix</span>
                            <p class="descricao">{{devolucao.chavePix | camelCase }}</p>
                          </div>
                        }
                        <div class="resolucao-detalhe">
                          <span class="label-detalhes">Data desconto</span>
                          @if (devolucao.dataDesconto) {
                            <p class="descricao"
                            >{{devolucao.dataDesconto | appDate: 'dd/MM/yyyy'}}</p>
                          }
                          @if (!devolucao.dataDesconto) {
                            <p class="descricao">Não consta</p>
                          }
                        </div>
                        <div class="resolucao-detalhe">
                          <span class="label-detalhes">Tipo devolução</span>
                          <p class="descricao">{{devolucao.tipoDevolucao}}</p>
                        </div>
                      </div>
                      <div class="seg-detalhe-devolucao">
                        <div class="col-12">
                          <span class="label-detalhes">Motivo operadora</span>
                          <p class="descricao">{{devolucao.motivoOperadora | camelCase}}</p>
                        </div>
                        <div class="col-12">
                          <span class="label-detalhes">Solução proposta</span>
                          <p class="descricao">{{devolucao.solucaoPadrao | camelCase}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
        @if (devolucoes || devolucoes === undefined) {
          <div class="paginacao-div">
            <app-paginacao
              paginacaoId="devolucoes"
              itensPorPaginaId="itensPorPaginaOperadora"
              [pageSize]="tamanho"
              [currentPage]="pagina"
              [totalItems]="totalItems"
              (pageChange)="getPageDevolucao($event)"
              (pageSizeChange)="alteraQuantidadePorPagina($event)">
            </app-paginacao>
          </div>
        }

        @if (devolucoes || devolucoes === undefined) {
          <div class="div-botao-relatorio">
            <button class="botao-relatorio-completo" (click)="downloadRelatorioCsv()"
              [disabled]="!('PedidosDevolucoesDepositoEmContaUsuario' | usuarioPermissao:'Imprimir' | async) || devolucoes === undefined"
                  [ngClass]="{
                      'disabled': !('PedidosDevolucoesDepositoEmContaUsuario' | usuarioPermissao:'Imprimir' | async),
                       'botao-relatorio-completo-disabled': devolucoes === undefined
                    }"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M2.00016 10C2.36835 10 2.66683 10.2985 2.66683 10.6667V12C2.66683 12.7364 3.26378 13.3333 4.00016 13.3333H12.0002C12.7365 13.3333 13.3335 12.7364 13.3335 12V10.6667C13.3335 10.2985 13.632 10 14.0002 10C14.3684 10 14.6668 10.2985 14.6668 10.6667V12C14.6668 13.4728 13.4729 14.6667 12.0002 14.6667H4.00016C2.5274 14.6667 1.3335 13.4728 1.3335 12V10.6667C1.3335 10.2985 1.63197 10 2.00016 10Z" fill="white"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00016 10.6667C7.63197 10.6667 7.3335 10.3682 7.3335 10L7.3335 2.00002C7.3335 1.63183 7.63197 1.33335 8.00016 1.33335C8.36835 1.33335 8.66683 1.63183 8.66683 2.00002L8.66683 10C8.66683 10.3682 8.36835 10.6667 8.00016 10.6667Z" fill="#FAFAF0"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.19526 6.19526C3.93491 6.45561 3.93491 6.87772 4.19526 7.13807L7.5286 10.4714C7.78894 10.7318 8.21106 10.7318 8.4714 10.4714L11.8047 7.13807C12.0651 6.87772 12.0651 6.45561 11.8047 6.19526C11.5444 5.93491 11.1223 5.93491 10.8619 6.19526L8 9.05719L5.13807 6.19526C4.87772 5.93491 4.45561 5.93491 4.19526 6.19526Z" fill="#FAFAF0"/>
            </svg>
            <span> BAIXAR RELATÓRIO COMPLETO</span>
          </button>
        </div>
      }
    </div>
  </div>
</div>
</div>

<app-footer></app-footer>
